import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { reservationArrowRightSvg } from '../assets/images';
import { Icon } from '../stories/Icon';

interface ReservationLiveClassDateAndTimeProps {
  dateTime?: string;
  className?: string;
}

export const ReservationLiveClassDateAndTime: React.FC<ReservationLiveClassDateAndTimeProps> = ({
  dateTime,
  className,
}) => {
  const __ = useTranslation().t;

  const momentDateTime = moment.utc(dateTime);
  const dayOfTheWeek = momentDateTime.isSame(new Date(), 'day')
    ? __('today')
    : momentDateTime.format('dddd');
  const liveClassDateString = momentDateTime.format('Do MMMM');
  const liveClassTimeString = momentDateTime.format('h:mm a');

  return (
    <StyledP className={className}>
      <StyledIcon name="calendar" />
      <>{`${dayOfTheWeek}, ${liveClassDateString}`}</>
      <StyledArrowImg src={reservationArrowRightSvg} alt="Arrow" />
      <StyledIcon name="clock" />
      <>{liveClassTimeString}</>
    </StyledP>
  );
};

const StyledP = styled.p`
  font-family: 'Inter';
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
`;

const StyledIcon = styled(Icon)`
  color: #323232;
  margin-right: 9px;
`;

const StyledArrowImg = styled.img`
  margin: 0 9px 0 8px;
`;
